
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconWa = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 33,
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon_wa_acadc09679f6c785__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon_wa_acadc09679f6c785__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.059 20.869 4.372 27l6.303-1.645a11.924 11.924 0 0 0 5.68 1.44h.006c6.552 0 11.886-5.309 11.89-11.832a11.732 11.732 0 0 0-3.48-8.371 11.842 11.842 0 0 0-8.41-3.47c-6.553 0-11.886 5.307-11.89 11.831 0 2.086.548 4.121 1.588 5.916zm5.269 2.556-.361-.213-3.74.977.998-3.63-.235-.371a9.777 9.777 0 0 1-1.51-5.234c.001-5.422 4.434-9.834 9.885-9.834a9.839 9.839 0 0 1 6.986 2.884 9.752 9.752 0 0 1 2.891 6.958c-.002 5.423-4.434 9.835-9.881 9.835h-.004a9.9 9.9 0 0 1-5.03-1.372z",
  fill: "#B3B3B3"
})), /*#__PURE__*/React.createElement("path", {
  d: "m4.25 26.878 1.687-6.13a11.77 11.77 0 0 1-1.587-5.916C4.353 8.308 9.686 3 16.239 3a11.843 11.843 0 0 1 8.41 3.47 11.732 11.732 0 0 1 3.479 8.371c-.003 6.524-5.337 11.832-11.89 11.832h-.004c-1.99 0-3.945-.497-5.682-1.44L4.25 26.878z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.242 4.999c-5.45 0-9.883 4.411-9.885 9.834a9.778 9.778 0 0 0 1.51 5.233l.236.372-.999 3.63 3.74-.977.362.213a9.902 9.902 0 0 0 5.029 1.371h.004c5.446 0 9.88-4.412 9.881-9.834a9.75 9.75 0 0 0-2.891-6.958 9.839 9.839 0 0 0-6.987-2.884z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.242 4.999c-5.45 0-9.883 4.411-9.885 9.834a9.778 9.778 0 0 0 1.51 5.233l.236.373-.999 3.628 3.74-.976.362.213a9.901 9.901 0 0 0 5.029 1.371h.004c5.446 0 9.88-4.412 9.881-9.835a9.75 9.75 0 0 0-2.891-6.957 9.839 9.839 0 0 0-6.987-2.884z",
  fill: "url(#icon_wa_acadc09679f6c785__c)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.268 9.885c-.223-.492-.457-.502-.669-.51l-.57-.008c-.197 0-.52.074-.791.37-.273.296-1.04 1.012-1.04 2.467s1.064 2.86 1.213 3.058c.148.198 2.055 3.279 5.074 4.464 2.51.986 3.02.79 3.565.74.545-.049 1.758-.715 2.005-1.406.247-.69.247-1.282.173-1.405-.074-.124-.272-.198-.57-.346-.297-.148-1.757-.863-2.03-.962-.271-.099-.47-.148-.668.148-.198.296-.767.962-.94 1.16-.173.197-.346.222-.644.074-.297-.148-1.254-.46-2.389-1.468-.883-.784-1.479-1.752-1.652-2.048-.174-.296-.019-.456.13-.603.134-.133.297-.346.446-.518.149-.173.198-.296.297-.493.099-.197.05-.37-.025-.518-.074-.148-.651-1.61-.915-2.196",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icon_wa_acadc09679f6c785__a",
  x: 0.25,
  y: 1,
  width: 32,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_206_1139"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_206_1139",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "icon_wa_acadc09679f6c785__b",
  x: 2.176,
  y: 0.925,
  width: 28.27,
  height: 28.271,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.098,
  result: "effect1_foregroundBlur_206_1139"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon_wa_acadc09679f6c785__c",
  x1: 7.593,
  y1: 6.229,
  x2: 7.692,
  y2: 23.044,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57D163"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23B33A"
})))));

      const __svgRaw = "<svg width=\"33\" height=\"33\" viewBox=\"0 0 33 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g filter=\"url(#ixkgim0ana)\">\r\n        <g filter=\"url(#zd2lzasudb)\">\r\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.059 20.869 4.372 27l6.303-1.645a11.924 11.924 0 0 0 5.68 1.44h.006c6.552 0 11.886-5.309 11.89-11.832a11.732 11.732 0 0 0-3.48-8.371 11.842 11.842 0 0 0-8.41-3.47c-6.553 0-11.886 5.307-11.89 11.831 0 2.086.548 4.121 1.588 5.916zm5.269 2.556-.361-.213-3.74.977.998-3.63-.235-.371a9.777 9.777 0 0 1-1.51-5.234c.001-5.422 4.434-9.834 9.885-9.834a9.839 9.839 0 0 1 6.986 2.884 9.752 9.752 0 0 1 2.891 6.958c-.002 5.423-4.434 9.835-9.881 9.835h-.004a9.9 9.9 0 0 1-5.03-1.372z\" fill=\"#B3B3B3\"/>\r\n        </g>\r\n        <path d=\"m4.25 26.878 1.687-6.13a11.77 11.77 0 0 1-1.587-5.916C4.353 8.308 9.686 3 16.239 3a11.843 11.843 0 0 1 8.41 3.47 11.732 11.732 0 0 1 3.479 8.371c-.003 6.524-5.337 11.832-11.89 11.832h-.004c-1.99 0-3.945-.497-5.682-1.44L4.25 26.878z\" fill=\"#fff\"/>\r\n        <path d=\"M16.242 4.999c-5.45 0-9.883 4.411-9.885 9.834a9.778 9.778 0 0 0 1.51 5.233l.236.372-.999 3.63 3.74-.977.362.213a9.902 9.902 0 0 0 5.029 1.371h.004c5.446 0 9.88-4.412 9.881-9.834a9.75 9.75 0 0 0-2.891-6.958 9.839 9.839 0 0 0-6.987-2.884z\" fill=\"#000\"/>\r\n        <path d=\"M16.242 4.999c-5.45 0-9.883 4.411-9.885 9.834a9.778 9.778 0 0 0 1.51 5.233l.236.373-.999 3.628 3.74-.976.362.213a9.901 9.901 0 0 0 5.029 1.371h.004c5.446 0 9.88-4.412 9.881-9.835a9.75 9.75 0 0 0-2.891-6.957 9.839 9.839 0 0 0-6.987-2.884z\" fill=\"url(#12auojoncc)\"/>\r\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.268 9.885c-.223-.492-.457-.502-.669-.51l-.57-.008c-.197 0-.52.074-.791.37-.273.296-1.04 1.012-1.04 2.467s1.064 2.86 1.213 3.058c.148.198 2.055 3.279 5.074 4.464 2.51.986 3.02.79 3.565.74.545-.049 1.758-.715 2.005-1.406.247-.69.247-1.282.173-1.405-.074-.124-.272-.198-.57-.346-.297-.148-1.757-.863-2.03-.962-.271-.099-.47-.148-.668.148-.198.296-.767.962-.94 1.16-.173.197-.346.222-.644.074-.297-.148-1.254-.46-2.389-1.468-.883-.784-1.479-1.752-1.652-2.048-.174-.296-.019-.456.13-.603.134-.133.297-.346.446-.518.149-.173.198-.296.297-.493.099-.197.05-.37-.025-.518-.074-.148-.651-1.61-.915-2.196\" fill=\"#fff\"/>\r\n    </g>\r\n    <defs>\r\n        <filter id=\"ixkgim0ana\" x=\".25\" y=\"1\" width=\"32\" height=\"32\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n            <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n            <feColorMatrix in=\"SourceAlpha\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n            <feOffset dy=\"2\"/>\r\n            <feGaussianBlur stdDeviation=\"2\"/>\r\n            <feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0\"/>\r\n            <feBlend in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_206_1139\"/>\r\n            <feBlend in=\"SourceGraphic\" in2=\"effect1_dropShadow_206_1139\" result=\"shape\"/>\r\n        </filter>\r\n        <filter id=\"zd2lzasudb\" x=\"2.176\" y=\".925\" width=\"28.27\" height=\"28.271\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n            <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n            <feBlend in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>\r\n            <feGaussianBlur stdDeviation=\"1.098\" result=\"effect1_foregroundBlur_206_1139\"/>\r\n        </filter>\r\n        <linearGradient id=\"12auojoncc\" x1=\"7.593\" y1=\"6.229\" x2=\"7.692\" y2=\"23.044\" gradientUnits=\"userSpaceOnUse\">\r\n            <stop stop-color=\"#57D163\"/>\r\n            <stop offset=\"1\" stop-color=\"#23B33A\"/>\r\n        </linearGradient>\r\n    </defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon_wa.acadc09679f6c785fa12fa1c2f54d9ca.svg"),
        {
          React: SvgIconWa,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      